module.exports = __webpack_public_path__ + "static/javascript_fullstack_online_bootcamp-b393033fd31a49cffedf4abb44012392.jpg";